import Vue from 'vue'
import Vuex from 'vuex'
//在vuex初始化时导入插件
import persist from 'vuex-persistedstate'
// import name from '../utils/userInfor'
// import name from '../App'
// //console.log('app',name.data.name);
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    userInfo: {},
    menu: []
  },
  getters: {

  },
  mutations: {
    UPDATE_USER_INFO(val, h) {
      // //console.log(this.state.userInfo);
      this.state.userInfo = h
      // //console.log('mutations',val,'--------',h);
    },
    UPDATE_MENU(val, h) {
      this.state.menu = h
    },
    DELETE_STATE() {
      this.state.menu = []
      this.state.userInfo = {}
    }
  },
  actions: {
    updateUserInfo(val, h) {
      this.commit('UPDATE_USER_INFO', h)
      // //console.log('actions',val,'----',h);
    },
    updateMenu(val, h) {
      this.commit('UPDATE_MENU', h)
    },
    deleteState() {
      this.commit('DELETE_STATE')
    }
  },
  modules: {
  },
  plugins: [
    new persist({
      // key: name.data.name,
      storage: window.sessionStorage,
    }),
  ],
})
